<style lang="scss" scoped>
img {
  min-width: 100%;
}

.hide-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  max-width: 85%;
}
.icon {
  position: relative;
  bottom: 10px;
}

.avatar {
  display: block;
  position: relative;
  width: 100%;
  background-size: cover;

  &::before {
    content: "";
    display: block;
    padding-top: 100%;
  }
}

.erotic-triangle {
  width: 0px;
  height: 0px;
  border-bottom: 110px solid $danger;
  border-left: 110px solid transparent;
  bottom: 0;
  right: 0;
  position: absolute;
  opacity: 0.8;
  filter: alpha(opacity=80);
  color: $white;
}
.erotic-triangle-text {
  position: absolute;
  padding: 1%;
  bottom: -124px;
  left: -64px;
  transform: rotate(-45deg);
  transform-origin: -20% 55%;
}

.new-member-triangle {
  width: 0px;
  height: 0px;
  border-top: 110px solid $blue;
  border-right: 110px solid transparent;
  top: 0;
  left: 0;
  position: absolute;
  opacity: 0.8;
  filter: alpha(opacity=80);
  color: $white;
}
.new-member-triangle-text {
  position: absolute;
  padding: 1%;
  bottom: 30px;
  left: 22px;
  transform: rotate(-45deg);
  transform-origin: -20% 55%;
}

.erotic-shadow {
  box-shadow: 0 0 1.5rem $danger !important;
}

.erotic-border-bottom {
  width: 100%;
  height: 0px;
  border-bottom: 15px solid $danger;
  bottom: 0;
  right: 0;
  position: absolute;
  opacity: 0.8;
  filter: alpha(opacity=80);
}

.new-member-border-bottom {
  width: 100%;
  height: 0px;
  border-bottom: 15px solid;
  bottom: 0;
  right: 0;
  position: absolute;
  opacity: 0.8;
  filter: alpha(opacity=80);
}

.new-member-erotic-border-bottom {
  width: 50%;
  height: 0px;
  border-bottom: 15px solid $danger;
  bottom: 0;
  right: 0;
  position: absolute;
  opacity: 0.8;
  filter: alpha(opacity=80);
}

.erotic-border {
  border: 2px solid $danger;
  position: absolute;
  opacity: 0.8;
  filter: alpha(opacity=80);
}
.erotic-border.border-1 {
  height: 100%;
  left: 0;
  top: 0;
}
.erotic-border.border-2 {
  height: 100%;
  right: 0;
  top: 0;
}
.erotic-border.border-3 {
  width: 100%;
  left: 0;
  top: 0;
}
.erotic-border.border-4 {
  width: 100%;
  left: 0;
  bottom: 0;
}

.cross-top-right {
  margin-right: 25px;
  margin-top: 5px;
  top: 0px;
  right: 0px;
}
.cross-top-right:after {
  left: -20px;
  top: 20px;
}
.cross-top-left {
  margin-left: 25px;
  margin-top: 5px;
  top: 0px;
  left: 0px;
}
.cross-top-left:after {
  right: -20px;
  top: 20px;
}
.cross-bottom-right {
  margin-right: 25px;
  margin-bottom: 5px;
  bottom: 0px;
  right: 0px;
}
.cross-bottom-right:after {
  left: -20px;
  bottom: 20px;
}
.cross-bottom-left {
  margin-left: 25px;
  margin-bottom: 5px;
  bottom: 0px;
  left: 0px;
}
.cross-bottom-left:after {
  right: -20px;
  bottom: 20px;
}
.cross-center {
  margin-bottom: 5px;
  bottom: calc(50% - 25px);
  left: calc(50% - 2px);
}
.cross-center:after {
  right: -20px;
  bottom: 20px;
}
.fake-profile-cross {
  background: var(--display-fake-color);
  height: 50px;
  width: 10px;
  position: absolute;
  opacity: 0.6;
  filter: alpha(opacity=80);
  transform: rotate(45deg);
}
.fake-profile-cross:after {
  background: var(--display-fake-color);
  content: "";
  height: 10px;
  width: 50px;
  position: absolute;
}
</style>

<style>
:root {
  --new-member-color: #000000 !important;
  --display-fake-color: #000000 !important;
}
.new-member-shadow {
  box-shadow: 0 0 1.5rem var(--new-member-color) !important;
}
.new-member-border-bottom,
.new-member-triangle {
  border-bottom-color: var(--new-member-color) !important;
}
.new-member-erotic-shadow {
  box-shadow: -0.3rem -0.3rem 1.5rem var(--new-member-color),
    0.3rem 0.3rem 1.5rem var(--danger) !important;
}
.new-member-erotic-border {
  border: 2px solid;
  position: absolute;
  opacity: 0.8;
  filter: alpha(opacity=80);
}
.new-member-erotic-border.border-1 {
  height: 100%;
  left: 0;
  top: 0;
  border-color: var(--new-member-color) !important;
}
.new-member-erotic-border.border-2 {
  height: 100%;
  right: 0;
  top: 0;
  border-color: var(--danger) !important;
}
.new-member-erotic-border.border-3 {
  width: 100%;
  left: 0;
  top: 0;
  border-color: var(--new-member-color) !important;
}
.new-member-erotic-border.border-4 {
  width: 100%;
  left: 0;
  bottom: 0;
  border-color: var(--danger) !important;
}

.new-member-border {
  border: 2px solid;
  position: absolute;
  opacity: 0.8;
  filter: alpha(opacity=80);
  border-color: var(--new-member-color) !important;
}

.new-member-border.border-1 {
  height: 100%;
  left: 0;
  top: 0;
}
.new-member-border.border-2 {
  height: 100%;
  right: 0;
  top: 0;
}
.new-member-border.border-3 {
  width: 100%;
  left: 0;
  top: 0;
}
.new-member-border.border-4 {
  width: 100%;
  left: 0;
  bottom: 0;
}
</style>

<template>
  <div :id="id" class="row rounded profile-shortInfo">
    <div
      class="col-12 border shadow"
      :class="{
        'erotic-shadow':
          profile.has_erotic &&
          displayErotic == 'shadow' &&
          (!profile.is_new || displayNewMembers != 'shadow'),
        'new-member-shadow':
          profile.is_new &&
          displayNewMembers == 'shadow' &&
          (!profile.has_erotic || displayErotic != 'shadow'),
        'new-member-erotic-shadow':
          profile.is_new &&
          displayNewMembers == 'shadow' &&
          profile.has_erotic &&
          displayErotic == 'shadow'
      }"
    >
      <div class="row">
        <div class="col-12 bg-white profile-shortInfo-picture p-0">
          <a
            v-if="!settings"
            @click="storeId"
            :href="profileUrl"
            class="avatar"
            :style="{ 'background-image': 'url(' + primaryImageUrl + ')' }"
          >
            <div v-if="mark.mode == 'cross' && profile.mark">
              <div
                v-if="mark.location == 'topRight'"
                class="fake-profile-cross cross-top-right"
              ></div>
              <div
                v-if="mark.location == 'topLeft'"
                class="fake-profile-cross cross-top-left"
              ></div>
              <div
                v-if="mark.location == 'bottomRight'"
                class="fake-profile-cross cross-bottom-right"
              ></div>
              <div
                v-if="mark.location == 'bottomLeft'"
                class="fake-profile-cross cross-bottom-left"
              ></div>
              <div
                v-if="mark.location == 'center'"
                class="cross-center fake-profile-cross"
              ></div>
            </div>
          </a>
          <div
            class="avatar"
            v-if="settings"
            :style="{ 'background-image': 'url(' + primaryImageUrl + ')' }"
          >
            <div v-if="mark.mode == 'cross'">
              <div
                v-if="mark.location == 'topRight'"
                class="fake-profile-cross cross-top-right"
              ></div>
              <div
                v-if="mark.location == 'topLeft'"
                class="fake-profile-cross cross-top-left"
              ></div>
              <div
                v-if="mark.location == 'bottomRight'"
                class="fake-profile-cross cross-bottom-right"
              ></div>
              <div
                v-if="mark.location == 'bottomLeft'"
                class="fake-profile-cross cross-bottom-left"
              ></div>
              <div
                v-if="mark.location == 'center'"
                class="cross-center fake-profile-cross"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div class="row bg-white pr-3 pl-3">
        <div class="col-12 pl-1 pt-2">
          <div class="row">
            <div class="col-12 text-primary">
              <a
                v-if="!settings && (!profile.mark || mark.mode != 'name')"
                @click="storeId"
                class="profile-name hide-overflow"
                :href="profileUrl"
                >{{ profile.name }}</a
              >
              <a
                v-if="!settings && profile.mark && mark.mode == 'name'"
                @click="storeId"
                class="profile-name hide-overflow"
                :href="profileUrl"
                >{{ mark.prefix }} {{ profile.name }} {{ mark.suffix }}</a
              >
              <span
                class="profile-name hide-overflow"
                v-if="settings && mark.mode != 'name'"
                >{{ profile.name }}</span
              >
              <span
                class="profile-name hide-overflow"
                v-if="settings && mark.mode == 'name'"
                >{{ mark.prefix }} {{ profile.name }} {{ mark.suffix }}</span
              >
              <i
                class="pl-1 fas fa-circle icon"
                :class="{ 'text-success': isOnline, 'text-danger': !isOnline }"
              ></i>
            </div>
          </div>
          <div class="row">
            <div class="col-12 text-primary">
              <label class="text-lg">{{ profile.sex }},</label>
              <label class="text-lg">{{ profile.age }} Jahre</label>
            </div>
          </div>
          <div class="row">
            <div class="col-12 pt-0 text-primary pb-3">
              <label class="profile-country"
                >{{ profile.country }}, {{ profile.anonymous_zipcode }}</label
              >
            </div>
          </div>
        </div>

        <span
          v-if="
            profile.has_erotic &&
              displayErotic == 'border' &&
              !(profile.is_new && displayNewMembers == 'border')
          "
        >
          <div class="erotic-border border-1"></div>
          <div class="erotic-border border-2"></div>
          <div class="erotic-border border-3"></div>
          <div class="erotic-border border-4"></div>
        </span>

        <span
          v-if="
            profile.is_new &&
              displayNewMembers == 'border' &&
              !(profile.has_erotic && displayErotic == 'border')
          "
        >
          <div class="new-member-border border-1"></div>
          <div class="new-member-border border-2"></div>
          <div class="new-member-border border-3"></div>
          <div class="new-member-border border-4"></div>
        </span>

        <span
          v-if="
            profile.has_erotic &&
              displayErotic == 'border' &&
              profile.is_new &&
              displayNewMembers == 'border'
          "
        >
          <div class="new-member-erotic-border border-1"></div>
          <div class="new-member-erotic-border border-2"></div>
          <div class="new-member-erotic-border border-3"></div>
          <div class="new-member-erotic-border border-4"></div>
        </span>

        <div
          v-if="profile.has_erotic && displayErotic == 'border-bottom'"
          class="erotic-border-bottom"
        ></div>
        <div
          v-if="profile.is_new && displayNewMembers == 'border-bottom'"
          class="new-member-border-bottom"
        ></div>
        <div
          v-if="
            profile.has_erotic &&
              displayErotic == 'border-bottom' &&
              profile.is_new &&
              displayNewMembers == 'border-bottom'
          "
          class="new-member-erotic-border-bottom"
        ></div>

        <div
          v-if="profile.has_erotic && displayErotic == 'triangle'"
          class="erotic-triangle text-xl"
        >
          <div class="erotic-triangle-text">Erotisch</div>
        </div>
        <div
          v-if="profile.is_new && displayNewMembers == 'triangle'"
          class="new-member-triangle text-xl"
        >
          <div class="new-member-triangle-text">Neu</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="babel">
export default {
  props:{
    id: {
      required: true,
      type: String
    },
    profile: {
      required: true,
      type: Object
    },
    displayErotic: {
      required: false,
      default: 'none',
      type: String
    },
    displayNewMembers: {
      required: false,
      default: 'none',
      type: String
    },
    settings: {
      required: false,
      default: false,
      type: Boolean
    },
    newMemberColor: {
      required: true,
      type: String
    },
    mark: {
      required: true,
      type: Object
    },
  },
  methods: {
    storeId(){
      localStorage.setItem("last-id", this.id);
    }
  },
  created() {
    document.body.style.setProperty('--new-member-color', this.newMemberColor);
    document.body.style.setProperty('--display-fake-color', this.mark.color);
  },
  computed: {
    isOnline() {
      return this.$store.getters["online/profileOnline"](this.profile.id);
    },
    primaryImageUrl() {
      return this.profile.primary_image.url + '?width=' + Laravel.settings.imagesize.memberSearchImages + '&height=' + Laravel.settings.imagesize.memberSearchImages;
    },
    profileUrl() {
      return `/mitglied/${this.profile.name}`;
    },
  }
};
</script>
